export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de',
  fallbackLocale: ['de', 'en'],
  datetimeFormats: {
    de: {
      numeric: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      short: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      },
      year: {
        year: 'numeric',
      },
      dateTime: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      },
    },
    en: {
      numeric: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      short: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      },
      year: {
        year: 'numeric',
      },
      dateTime: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      },
    },
  },
}))
